/* ===== Header sticky ===== */
(function () {
  window.addEventListener('scroll', function () {
    var header = document.querySelector('.header-wrapper');
    if (!header) return;
    var scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollPosition > 30) {
      header.classList.add('sticky-ykbar');
    } else {
      header.classList.remove('sticky-ykbar');
    }
  }, { passive: true });
})();

/* ===== Smooth scroll for anchor links ===== */
(function () {
  function initSmoothScroll() {
    var anchors = document.querySelectorAll('a[href^="#"]:not([href="#"])');
    if (!anchors.length) return;

    anchors.forEach(function (anchor) {
      anchor.addEventListener('click', function (e) {
        var targetId = this.getAttribute('href');
        var target = document.querySelector(targetId);

        if (!target) {
          return;
        }

        e.preventDefault();
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSmoothScroll);
  } else {
    initSmoothScroll();
  }
})();
